import type { AppApi, EDITOR_TYPE } from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { newDynamicPageIntroPanel as newDynamicPageIntroPanelDef } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'
import { DIMENSIONS, NEW_DYNAMIC_PAGE_INTRO_PANEL_ACTIONS } from './consts'

interface PanelOpenerProps {
  hostname: string
  editorSdkProxy: EditorSDK
  editorType: EDITOR_TYPE
  appApi: AppApi
  origin: string
}

export const openPanel = async ({
  hostname,
  editorSdkProxy,
  editorType,
  appApi,
  origin,
}: PanelOpenerProps) => {
  const { width, height } = DIMENSIONS

  const panelResult = await editorSdkProxy.editor.openModalPanel({
    url: await getPanelUrl({
      hostname,
      relativeUrl: newDynamicPageIntroPanelDef.url,
      editorSdkProxy,
    }),
    width,
    height,
    shouldHideHeader: true,
    initialData: {
      origin,
      editorType,
    },
  })

  if (!panelResult) {
    return
  }

  const { type } = panelResult

  if (type === NEW_DYNAMIC_PAGE_INTRO_PANEL_ACTIONS.OPEN_PRESETS_MODAL) {
    return appApi.openAddDynamicPagePanelV4({
      origin,
    })
  }

  if (
    type === NEW_DYNAMIC_PAGE_INTRO_PANEL_ACTIONS.OPEN_CREATE_COLLECTION_PANEL
  ) {
    return appApi.openCreateCollectionPanel({
      origin,
    })
  }
  return
}
